const API_ENDPOINT = {
    RequestOrder: 'request-orders',
};

const fetchAPI = async (
    endpoint,
    method = 'GET',
    data = null,
    headers = {}
) => {
    const defaultHeaders = {
        'Content-Type': 'application/json',
    };

    const options = {
        method,
        headers: { ...defaultHeaders, ...headers },
    };

    if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
        options.body = JSON.stringify(data);
    }

    try {
        const response = await fetch(
            `https://api.printdropexpress.com/${endpoint}`,
            options
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('API request failed:', error);
        throw error;
    }
};
